import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { Alert } from '../../../../alerts';
import * as alertActions from '../../../../alerts/actions';

import {
    Row,
    Col,
    Button,
    FormGroup,
    ControlLabel,
    FormControl,
    HelpBlock,
    Radio
} from 'react-bootstrap';
import statesArray from '../../../../utils/statesArray';
import client from '../../../../../apollo/client';
import gql from 'graphql-tag';



export class BrokerStateMapping extends Component {
    constructor(props) {
        super(props);
        this.state = {
            stateArray : statesArray,
            agency: this.props.authAgency,
            mappedState : !!this.props.authAgency.authStates && this.props.authAgency.authStates.length > 0 ? this.props.authAgency.authStates : [],
            errorDialog : false,
            isSelectedState : false,
            isMappedState : false,
            displayMessage: false,
        }
        this.updateMapState = this.updateMapState.bind(this);
        this.updateBrokerState = this.updateBrokerState.bind(this);
        this.selectAllState = this.selectAllState.bind(this);
    }

    buildStateList() {
        return(
            statesArray.map((rowVal, idx) => {
                if (!!this.state.mappedState && this.state.mappedState.indexOf(rowVal.text) >= 0 || idx == 0) {
                    return null;
                }
                return (
                    <option key={idx} className="remainingField" onClick = {() =>this.updateMapState(rowVal.text, 0)}>
                        {rowVal.text}
                    </option>
                );
            })
        )
    }

    showMappedStateList() {
        if(!this.state.mappedState) return null;
        return(
            this.state.mappedState.map((ele, idx) => {
                return (
                    <div key={idx} className="remainingField">
                        {ele}
                        <span key={idx} onClick = {() =>this.updateMapState(idx, 1)}>X</span> 
                    </div>
                );
            })
        )
    }

    selectAllState(element, selected = -1) {
        this.state.mappedState = [];
        if(selected == 0 ) {
            this.state.isSelectedState = false
            this.state.isMappedState = true
            this.state.stateArray = statesArray;
            let arrState = this.state.stateArray;
            if(arrState[0].optionId == '1') arrState.splice(0, 1);
            arrState.forEach(element => {
                this.state.mappedState.push(element.value)
            });
        } else if(selected == 1 ) {
            this.state.isMappedState = false;
            this.state.stateArray = statesArray;
        }

        this.setState({
            ...this.state,
            mappedState : this.state.mappedState,
            stateArray : this.state.stateArray
        });
    }

    updateMapState(index, item) {
        let objStateList = this.state.mappedState;
        if (item == 0) {
            objStateList.push(index);
        } else if (item == 1) {
            objStateList.splice(index, 1);
        } 
        this.setState({
            ...this.state,
            mappedState : objStateList,
        });
    }

    updateBrokerState = async () => {
        const responce = await client.query({
            variables: {
                brokerId : this.state.agency.brokerId,
                authStates: this.state.mappedState
            },
            query: gql`
            query brokerageStateUpdate($brokerId: ID! $authStates : [String]) {
                brokerageStateUpdate(brokerId: $brokerId authStates: $authStates) { name }
            }`
        });
        if (responce.data) {
            this.props.updateStateObject(this.state.agency.brokerId, this.state.mappedState);
            this.setState({displayMessage : true})
             setTimeout(()=>{
                this.setState({displayMessage : false})
            }, 2000)
        } else {
            this.setState({
                errorDialog : true
            })
        }
    }

    render() {
        let isSelectedState = this.state.isSelectedState;
        let isMapedState = this.state.isMappedState;
        let statusMessage = this.state.displayMessage == true ? "Data updated sucessfully" : "";
        return (
            <div className="stateMapModal">
                <div className="dropdownStateList">
                    <div className="headerContainer">
                        <p className="mbottom_0">Select state to map with the agency</p>
                        <span className="col-xs-12 no_pad pbottom_10 fsize_12">Note: If no states are mapped, the agency will be allowed all 50 states by default</span>
                        <div className="rightLabel" onClick={() =>this.selectAllState(this, 0)}><input checked={isSelectedState} type="checkbox" /><label>Select all state </label></div>
                    </div>
                    <select className="mdb-select colorful-select dropdown-primary md-form" multiple>
                        {this.buildStateList()}
                    </select>
                </div>
                <div className="selectedBrokersState">
                    <div className="headerContainer">
                        <p>Brokerage mapped state</p>
                        <div className="rightLabel" onClick={() =>this.selectAllState(this, 1)}><input checked={isMapedState} type="checkbox" /><label>Remove all state </label></div>
                    </div>
                    <div className="mappedStateList">{this.showMappedStateList()}</div>
                </div>
                {(this.state.displayMessage == true) &&<div role="alert" className="alert alert-success alert-dismissable"><div>{statusMessage}</div></div>
                }
                <div className="row">
                    <button className="btn btn-default pull-right" onClick={() =>this.updateBrokerState()}>Update Broker State</button>
                </div>
            </div>
        );
    }
}

BrokerStateMapping.propTypes = {
    hideEditModal: PropTypes.func
};

export default connect(state => {
    return {
        user: state
    };
})(BrokerStateMapping);